import _ = require('underscore');

const INDICATOR_MAXIMUM_MESSAGE_LENGTH: number = 4000;

export type IllegalLabel = 'TOOLONG' | 'NOMESSAGE';

export type SubmitLabelCommand = IllegalLabel | 'SUBMIT' | 'DELETE';

export function canSubmitLabel(params: { message: string, active: boolean }): SubmitLabelCommand {
  const { message, active  } = params;

  if (message.length > INDICATOR_MAXIMUM_MESSAGE_LENGTH) {
    return 'TOOLONG';
  }

  if (_.isEmpty(message.trim())) {
    return !active ? 'DELETE' : 'NOMESSAGE';
  }

  return 'SUBMIT';
}
